/**
 * FirstWinNudgeCard — compact home-feed card for hackers who SKIPPED the
 * first-win wizard but still have zero flags. One click re-opens the wizard
 * (FirstWinWizard listens for the `hc:open-first-win` event).
 */
import { useEffect, useState } from "react";
import { Flag, ArrowRight, X } from "@phosphor-icons/react";
import { api } from "../lib/api";

const HIDE_KEY = "hc_fw_nudge_hide";

export default function FirstWinNudgeCard() {
    const [nudge, setNudge] = useState(false);
    const [points, setPoints] = useState(25);
    const [hidden, setHidden] = useState(() => {
        try { return localStorage.getItem(HIDE_KEY) === "1"; } catch { return false; }
    });

    useEffect(() => {
        if (hidden) return;
        let dead = false;
        api.get("/onboarding/first-win")
            .then((r) => {
                if (!dead && r.data?.nudge) {
                    setNudge(true);
                    setPoints(r.data.challenge?.points ?? 25);
                }
            })
            .catch(() => {});
        const solved = () => setNudge(false);
        window.addEventListener("hc:first-win-solved", solved);
        return () => { dead = true; window.removeEventListener("hc:first-win-solved", solved); };
    }, [hidden]);

    if (hidden || !nudge) return null;

    const hide = () => {
        try { localStorage.setItem(HIDE_KEY, "1"); } catch { /* noop */ }
        setHidden(true);
    };

    return (
        <div className="hc-card p-3.5 flex items-center gap-3 bg-cyan-500/[0.04]" data-testid="first-win-nudge-card">
            <div className="shrink-0 w-9 h-9 rounded-sm border border-cyan-500/30 bg-cyan-500/10 flex items-center justify-center">
                <Flag size={17} weight="duotone" className="text-cyan-300" />
            </div>
            <div className="min-w-0 flex-1">
                <div className="text-sm font-bold text-slate-100" style={{ fontFamily: "'Space Grotesk', 'Chivo', sans-serif" }}>
                    Unfinished business: your first flag is still out there.
                </div>
                <div className="text-[11px] text-slate-400 font-mono mt-0.5">
                    +{points} karma · +30 XP waiting · ~15 min, no tooling needed
                </div>
            </div>
            <button
                onClick={() => window.dispatchEvent(new CustomEvent("hc:open-first-win"))}
                data-testid="first-win-nudge-resume"
                className="shrink-0 text-[10px] uppercase tracking-widest font-mono bg-cyan-500/10 border border-cyan-500/40 text-cyan-300 hover:bg-cyan-500/20 px-3 py-1.5 rounded-sm flex items-center gap-1.5"
            >
                resume mission <ArrowRight size={10} />
            </button>
            <button onClick={hide} data-testid="first-win-nudge-hide" title="Hide"
                    className="shrink-0 text-slate-600 hover:text-slate-300 p-1">
                <X size={12} />
            </button>
        </div>
    );
}
